<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title,leftIcon } = context.props
    const vnodes = []
    //
    // if (icon) {
    //   vnodes.push(<svg-icon icon-class={icon}/>)
    // }
    // if (leftIcon){
    //
    // }

    // const vnode = h('div', [h('i', { class: 'el-icon-arrow-right' }) ])// 假设使用Font Awesome图标
    //
    // vnodes.push(vnode)
if (icon){
  const myColor = '#4B830A'
  console.log("-----测试" + icon)
  const vnode2 = h('i', { class: icon ,style:{color: myColor}}) // 假设使用Font Awesome图标
  // const vnode2 = h('i', { class: icon ,style:"color: #4B830A,with:40px"}) // 假设使用Font Awesome图标
  // const vnode2 = h('i', { class: 'el-icon-arrow-right' ,style:"color: #4B830A,with:40px"}) // 假设使用Font Awesome图标

  vnodes.push(vnode2)
}


    // vnodes.push(<span>{title}</span>)
// console.log(vnodes)
    if (title) {
      if (title.length > 6) {
        vnodes.push(<span slot='title' title={(title)}>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>
